const baseUrl = 'https://www.coinglobal.top'

export {
  baseUrl
}



// WEBPACK FOOTER //
// ./src/utils/config.js